export const themeStyleDark = {
  backgroundColor: "#F4F5FA",
  primaryColor: "#803D3B",
  primaryCardColor: "white",
  textColor: "black",
  primaryButtonColor: "#803D3B",
  primaryButtonTextColor: "white",
  secondaryButtonColor: "#000080",
};

export const themeStyle = {
  backgroundColor: "#F4F5FA",
  primaryColor: "#803D3B",
  primaryCardColor: "white",
  textColor: "black",
  primaryButtonColor: "#803D3B",
  primaryButtonTextColor: "black",
  secondaryButtonColor: "#000080",
};
